import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import toast from 'react-hot-toast';
import { Zap } from 'lucide-react';

export default function Login() {
  const [form, setForm] = useState({ email:'', password:'' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', padding:20 }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:40 }}>
          <div style={{ width:52, height:52, borderRadius:14, background:'var(--accent)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 0 30px rgba(108,99,255,0.4)' }}>
            <Zap size={24} color="white" fill="white" />
          </div>
          <h1 style={{ fontSize:28, fontWeight:800, marginBottom:6 }}>{t('login.title')}</h1>
          <p style={{ color:'var(--text-secondary)', fontSize:14 }}>{t('login.subtitle')}</p>
        </div>
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('login.email')}</label>
              <input type="email" placeholder="you@example.com" value={form.email} onChange={e => setForm({...form, email:e.target.value})} required />
            </div>
            <div className="form-group">
              <label>{t('login.password')}</label>
              <input type="password" placeholder="••••••••" value={form.password} onChange={e => setForm({...form, password:e.target.value})} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'12px', marginTop:8 }} disabled={loading}>
              {loading ? <span className="spinner" /> : t('login.submit')}
            </button>
          </form>
        </div>
        <p style={{ textAlign:'center', marginTop:20, fontSize:14, color:'var(--text-secondary)' }}>
          {t('login.noAccount')} <Link to="/register" style={{ color:'var(--accent-light)', textDecoration:'none', fontWeight:500 }}>{t('login.createOne')}</Link>
        </p>
      </div>
    </div>
  );
}
